import { ethers } from "ethers";
const MAX_UINT = "0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff";
export const constantVariables = {
    addressZero: ethers.constants.AddressZero,
    maxUint: MAX_UINT,
    hashZero: ethers.constants.HashZero,
};
//# sourceMappingURL=constantVariables.js.map